import MockAdapter from 'axios-mock-adapter';
import { mockBankAccountResponse } from '../BankAccount/BankAccount.mock';

export function RegisterCommonDataStructureMocks(adapter: MockAdapter) {
  mockBankAccountResponse(adapter);
}
